import liveTv from './assets/liveTv.svg';
import liveTv2 from './assets/liveTv2.svg';
import doc1 from './assets/doc1.svg';
import doc2 from './assets/doc2.svg';
import angle from './assets/angle.svg';
import bookmark from './assets/bookmark.svg';
import group1 from './assets/group1.svg';
import chat1 from './assets/chat1.svg';
import location from './assets/location.svg';
import tablet from './assets/tablet.svg';
import laptop from './assets/laptop.svg';
import rocket from './assets/rocket.svg';
import rising from './assets/rising.svg';
import book from './assets/book.svg';
import instagram from './assets/instagram.svg';
import facebook from './assets/facebook.svg';
import youtube from './assets/youtube.svg';
import telegram from './assets/telegram.svg';
import linkedin from './assets/linkedin.svg';
import group2 from './assets/group2.svg';
import avatar from './assets/avatar.svg';
import chat2 from './assets/chat2.svg';
import email from './assets/email.svg';
import phone from './assets/phone.svg';
import facebook2 from './assets/facebook2.svg';
import twitter from './assets/twitter.svg';
import menu from './assets/menu.svg';
import clpLogo from './assets/clpLogo.svg';
import videoPlay from './assets/videoPlay.svg';
import stockGrowth from './assets/stockGrowth.svg';
import money from './assets/money.svg';
import split from './assets/split.svg';
import chart from './assets/chart.svg';
import women from './assets/women.svg';
import leaders from './assets/leaders.svg';
import program from './assets/program.svg';
import sessions from './assets/sessions.svg';
import videoEditing from './assets/videoEditing.svg';
import camera from './assets/camera.svg';
import editing from './assets/editing.svg';
import regularBatches from './assets/regularBatches.svg';
import alternateBatches from './assets/alternateBatches.svg';
import weekendBatches from './assets/weekendBatches.svg';
import girl from './assets/girl.svg';
import smile from './assets/smile.svg';
import relationships from './assets/relationships.svg';
import vocal from './assets/vocal.svg';
import instrument from './assets/instrument.svg';
import music from './assets/music.svg';
import workout from './assets/workout.svg';
import trainer from './assets/trainer.svg';
import barbell from './assets/barbell.svg';
import report from './assets/report.svg';
import college from './assets/college.svg';
import govtExam from './assets/govtExam.svg';
import teachers from './assets/teachers.svg';
import learning from './assets/learning.svg';
import success from './assets/success.svg';
import quote from './assets/quote.svg';
import clock from './assets/clock.svg';
import bookSaved from './assets/book-saved.svg';
import certificate from './assets/certificate.svg';
import calendar from './assets/calendar.svg';
import video from './assets/video.svg';
import bookSavedIcon from './assets/bookSaved.svg';
import teacherIcon from './assets/teacherIcon.svg';
import medalIcon from './assets/medal.svg';
import groupProfile from './assets/groupProfile.svg';

/** @returns {import('./types').IconData} */
const getConfiguredIcon1 = (url) => ({ url, svgChildrenConfigs: [] });

/** @returns {import('./types').IconData} */
const getConfiguredIcon2 = (url, stroke, fill) => ({
  url,
  svgChildrenConfigs: [{ selector: 'path', stroke, fill }]
});

export const icons = {
  'Live class': getConfiguredIcon2(liveTv, false, true),
  'Recorded videos': getConfiguredIcon2(liveTv2, false, true),
  Menu: getConfiguredIcon2(menu, false, true),
  ClpLogo: getConfiguredIcon1(clpLogo),
  Tests: getConfiguredIcon2(doc1, false, true),
  Assignments: getConfiguredIcon2(doc2, false, true),
  Courses: getConfiguredIcon2(bookmark, false, true),
  'One on one coaching': getConfiguredIcon2(group1, false, true),
  Chats: getConfiguredIcon2(chat1, false, true),
  Location: getConfiguredIcon2(location, false, true),
  'Mobile icon': getConfiguredIcon2(tablet, false, true),
  'Desktop icon': getConfiguredIcon2(laptop, false, true),
  'Rocket icon': getConfiguredIcon2(rocket, false, true),
  'Growth chart icon': getConfiguredIcon2(rising, true, false),
  'Book icon': getConfiguredIcon2(book, false, true),
  Instagram: getConfiguredIcon2(instagram, false, true),
  Facebook: getConfiguredIcon2(facebook, true, false),
  'Facebook Solid': getConfiguredIcon2(facebook2, false, true),
  YouTube: getConfiguredIcon2(youtube, false, true),
  Telegram: getConfiguredIcon2(telegram, false, true),
  LinkedIn: getConfiguredIcon2(linkedin, false, true),
  'Group icon': getConfiguredIcon2(group2, false, true),
  'Teacher icon': getConfiguredIcon2(avatar, false, true),
  'Help & Support': getConfiguredIcon2(chat2, false, true),
  Angle: getConfiguredIcon2(angle, false, true),
  Phone: getConfiguredIcon2(phone, false, true),
  Email: getConfiguredIcon2(email, false, true),
  'Twitter Solid': getConfiguredIcon2(twitter, false, true),
  'Video Play': getConfiguredIcon2(videoPlay, false, true),
  Quote: getConfiguredIcon2(quote, false, true),

  // Stock

  'Stock Growth': getConfiguredIcon2(stockGrowth, false, true),
  Money: getConfiguredIcon2(money, false, true),
  Split: getConfiguredIcon2(split, false, true),
  Chart: getConfiguredIcon2(chart, false, true),

  // Personality Development

  Leaders: getConfiguredIcon2(leaders, false, true),
  Women: getConfiguredIcon2(women, false, true),
  Program: getConfiguredIcon2(program, false, true),

  // Photography

  'Video Editing': getConfiguredIcon2(videoEditing, false, true),
  Editing: getConfiguredIcon2(editing, false, true),
  Camera: getConfiguredIcon2(camera, false, true),
  Sessions: getConfiguredIcon2(sessions, false, true),

  // Computer

  'Regular Batches': getConfiguredIcon2(regularBatches, false, true),
  'Alternate Batches': getConfiguredIcon2(alternateBatches, false, true),
  'Weekend Batches': getConfiguredIcon2(weekendBatches, false, true),

  // Life Coach

  Girl: getConfiguredIcon2(girl, false, true),
  Smile: getConfiguredIcon2(smile, false, true),
  Relationships: getConfiguredIcon2(relationships, false, true),

  // Music

  Vocal: getConfiguredIcon2(vocal, false, true),
  Instrument: getConfiguredIcon2(instrument, false, true),
  Music: getConfiguredIcon2(music, false, true),

  // Fitness

  Workout: getConfiguredIcon2(workout, false, true),
  Barbell: getConfiguredIcon2(barbell, false, true),
  Trainer: getConfiguredIcon2(trainer, false, true),
  Report: getConfiguredIcon2(report, false, true),

  // Govt Exam

  'Govt Exam': getConfiguredIcon2(govtExam, false, true),

  // IIT JEE

  College: getConfiguredIcon2(college, false, true),

  // Others

  Teachers: getConfiguredIcon2(teachers, false, true),
  Learning: getConfiguredIcon2(learning, false, true),
  Success: getConfiguredIcon2(success, false, true),

  // landing pages
  Clock: getConfiguredIcon2(clock, false, true),
  'Book Saved': getConfiguredIcon2(bookSaved, false, true),
  Certificate: getConfiguredIcon2(certificate, false, true),
  Calendar: getConfiguredIcon2(calendar, false, true),
  Video: getConfiguredIcon2(video, false, true),

  BookSaved: getConfiguredIcon2(bookSavedIcon, false, true),
  Teacher: getConfiguredIcon2(teacherIcon, false, true),
  Medal: getConfiguredIcon2(medalIcon, false, true),
  GroupProfile: getConfiguredIcon2(groupProfile, false, true)
};
